import React from "react";
import { useEffect } from "react";
import Hammer, { DIRECTION_VERTICAL } from "hammerjs";
import "./LineList.css";
import { useTranslation } from "react-i18next";
import { Children } from "react";
import { useState } from "react";
import { useRef } from "react";
import ReactHammer from "react-hammerjs";
import { Pan, PointerListener } from "contactjs";
import { useCallback } from "react";

const ITEM_HEIGHT = 140;
const FULL_ITEM_HEIGHT = 300;

const LineList = ({ children }) => {
  const slide = useRef(0);
  const currentSlideTranslation = useRef(0);
  const previousSlideTranslation = useRef(0);
  const listRef = useRef(null);
  const [currentSlide, setcurrentSlide] = useState(0);

  // Used to wrap child elements in JSX and also count them
  const pannableElements = Children.toArray(children);

  const goToSlide = (number) => {
    slide.current = number;
    setcurrentSlide(number);
  };

  const getNextSlideIndex = (deltaY) => {
    // Going up
    if (deltaY > 0) {
      return Math.max(0, slide.current - 1);
    }

    // Going down
    return Math.min(pannableElements.length - 1, slide.current + 1);
  };

  const getSlide = (index) => {
    return listRef.current.querySelector("#pannable-element--" + index);
  };

  const scrollTo = (offset, animated = false) => {
    if (animated) {
      listRef.current.classList.add("animated");
    }

    listRef.current.style.transform = `translateY(${offset}px)`;

    if (animated) {
      setTimeout(() => {
        listRef.current.classList.remove("animated");
      }, 200);
    }
  };

  const onPanEnd = useCallback((e) => {
    const deltaY = e.detail.global.deltaY;

    // Si le déplacement est suffisant, on change de slide
    if (Math.abs(deltaY) > 30) {
      goToSlide(getNextSlideIndex(deltaY));
    }
    // Sinon, on reset les changements de taille
    else {
      const currentSlideElement = getSlide(slide.current);
      const nextSlideElement = getSlide(getNextSlideIndex(deltaY));

      if (null !== currentSlideElement) {
        currentSlideElement.style.height = FULL_ITEM_HEIGHT + "px";
      }
      if (null !== currentSlideElement) {
        nextSlideElement.style.height = ITEM_HEIGHT + "px";
      }
    }

    const index = slide.current;

    const offsetTop = index * ITEM_HEIGHT;

    currentSlideTranslation.current = -offsetTop;
    previousSlideTranslation.current = -offsetTop;
    scrollTo(currentSlideTranslation.current, true);
  });

  const onPan = useCallback((e) => {
    const deltaY = e.detail.global.deltaY;

    const percent = Math.min(1, Math.abs(deltaY) / ITEM_HEIGHT);

    const heightDiff = (FULL_ITEM_HEIGHT - ITEM_HEIGHT) * percent;
    const currentSlideElement = getSlide(slide.current);
    const nextSlideElement = getSlide(getNextSlideIndex(deltaY));

    if (null !== currentSlideElement) {
      currentSlideElement.style.height = FULL_ITEM_HEIGHT - heightDiff + "px";
    }
    if (null !== nextSlideElement) {
      nextSlideElement.style.height = ITEM_HEIGHT + heightDiff + "px";
    }

    const diff =
      deltaY -
      currentSlideTranslation.current +
      previousSlideTranslation.current;

    // Don't go too far up
    if (diff > 0) {
      // Slide position
      const previousTranslation = previousSlideTranslation.current;

      // TODO check, la seconde condition englobe probablement les 2 à la fois
      // On ne doit pas pouvoir "monter" plus haut que 0
      // On ne doit pas pouvoir "monter" plus haut que la slide précédente
      currentSlideTranslation.current = Math.min(
        Math.min(previousTranslation + ITEM_HEIGHT, 0),
        currentSlideTranslation.current + diff
      );
    }
    // Don't go too far down
    else if (diff < 0) {
      const previousTranslation = previousSlideTranslation.current;

      const maxHeight =
        pannableElements.length * ITEM_HEIGHT +
        (FULL_ITEM_HEIGHT - ITEM_HEIGHT);

      // TODO check, la seconde condition englobe probablement les 2 à la fois
      // On ne doit pas pouvoir "descendre" plus bas que la dernière slide
      // On ne doit pas pouvoir "descendre" plus bas que la slide suivante
      currentSlideTranslation.current = Math.max(
        Math.max(
          previousTranslation - ITEM_HEIGHT,
          -maxHeight + FULL_ITEM_HEIGHT
        ),
        currentSlideTranslation.current + diff
      );
    }

    scrollTo(currentSlideTranslation.current);
  });

  useEffect(() => {
    const list = listRef.current;
    const options = {
      supportedGestures: [Pan],
    };

    new PointerListener(list, options);

    list.addEventListener("panend", onPanEnd);
    list.addEventListener("pan", onPan);

    return () => {
      console.log("removing event listeners");
      list.removeEventListener("panend", onPanEnd);
      list.removeEventListener("pan", onPan);
    };
  }, []);

  return (
    <div className="pannable-list">
      <div ref={listRef}>
        {pannableElements.map((element, index) => (
          <div
            key={index}
            className="pannable-list__element"
            id={`pannable-element--${index}`}
            style={{
              height: index === currentSlide ? FULL_ITEM_HEIGHT : ITEM_HEIGHT,
            }}
          >
            {element}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LineList;
